import * as React from 'react';
import { EMAIL_REGEX } from '../constants/constants';

interface InputError {
  message: string;
}

interface InputProps {
  id: string;
  onChange: (value: string) => void;
  type: string;
  disabled?: boolean;
  placeholder?: string;
  required?: boolean;
  value?: string | number;
  name?: string;
  hideErrorMessages?: boolean;
  checked?: boolean;
}

interface InputState {
  classNames: string;
  errors: Array<InputError>;
  isValid: boolean | null;
  value: string | number;
  checked: boolean;
}

class Input extends React.Component<InputProps, InputState> {
  constructor(props: InputProps) {
    super(props);
    this.state = {
      value: this.props.value ? this.props.value : '',
      isValid: null,
      errors: [],
      classNames: 'untouched',
      checked: false
    };
  }

  onValueChange(event: React.ChangeEvent<HTMLInputElement>) {
    const target = event.target;
    let value: string | boolean;
    if (this.props.type === 'checkbox') {
      value = target.checked;
      this.setState({
        checked: target.checked
      });
      value = target.checked === true ? 'true' : 'false';
    } else {
      value = target.value;
      this.setState({
        value: value
      });
    }

    this.setValidityAndClassnames(value);
    this.props.onChange(value);
  }

  componentWillReceiveProps(props: InputProps) {
    if (props.value) {
      this.setState({ value: props.value });
    }
  }

  setValidityAndClassnames(value: string | boolean) {
    let classNames: string = '';
    let valid: boolean = true;
    let errors: InputError[] = [];

    classNames += ' touched';

    if (this.props.required) {
      if (!value) {
        valid = false;
        errors.push({ message: 'Pakollinen kenttä' });
      }
    }

    switch (this.props.type) {
      case 'text':
        break;

      case 'number':
        break;

      case 'email':
        if (typeof value === 'string' && value !== '' && !EMAIL_REGEX.test(value)) {
          valid = false;
          errors.push({ message: 'Sähköpostin pitää olla muotoa esimerkki@esim.fi' });
        }
        break;

      default:
        break;
    }

    if (!valid) {
      classNames += ' invalid';
    } else {
      classNames += ' valid';
    }

    this.setState({
      classNames: classNames,
      errors: errors,
      isValid: valid
    });
  }

  onKeyUp(e: React.KeyboardEvent<HTMLInputElement>) {
    if (e.keyCode && e.keyCode === 13) {
      e.currentTarget.blur();
    }
  }

  errors() {
    if (!this.state.isValid && !this.props.hideErrorMessages) {
      return (
        <div className="errors">
          {
            this.state.errors.map((error, index) => (
              <span
                className="error"
                key={index}
              >{error.message}
              </span>
            ))
          }
        </div>
      );
    } else {
      return null;
    }
  }

  render() {
    if (this.props.type === 'checkbox') {
      return (
        <div className="input">
        <input
          id={this.props.id}
          className={this.state.classNames}
          type={this.props.type}
          checked={this.props.checked}
          onChange={(e) => this.onValueChange(e)}
          disabled={this.props.disabled}
          placeholder={this.props.placeholder}
          name={this.props.name}
          onKeyUp={e => this.onKeyUp(e)}
        />
        {this.errors()}
      </div>
      );
    }

    return (
      <div className="input">
        <input
          id={this.props.id}
          className={this.state.classNames}
          type={this.props.type}
          value={this.state.value}
          onChange={(e) => this.onValueChange(e)}
          disabled={this.props.disabled}
          placeholder={this.props.placeholder}
          name={this.props.name}
          onKeyUp={e => this.onKeyUp(e)}
        />
        {this.errors()}
      </div>
    );
  }
}

export default Input;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Input.tsx